import { render } from "./AccountSidebar.vue?vue&type=template&id=1b9d203c&scoped=true"
import script from "./AccountSidebar.vue?vue&type=script&lang=js"
export * from "./AccountSidebar.vue?vue&type=script&lang=js"

import "./AccountSidebar.vue?vue&type=style&index=0&id=1b9d203c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9d203c"]])

export default __exports__